import {SpriteView} from './SpriteView'
import {PIXI} from '@colonist/pixi'
import {SectionBgView} from './SectionBgView'
import {Sprites} from '../ui_game/UIGameImageDictionary'
import {UIGameSpriteHandler} from '../UIGameSpriteHandler'

export class TradeArrowView extends SectionBgView {
    private readonly arrow: SpriteView

    constructor(x: number, y: number, size: number, container: PIXI.Container, green: boolean, centerYInParent: boolean = true) {
        super(x, y, size, size, container)

        let texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trade_arrow_red)
        if(green) texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_trade_arrow_green)

        this.arrow = new SpriteView(0, 0, this.width, this.height, this, texture)
        if(centerYInParent) this.centerYInParent()
    }

    private centerYInParent() {
        if(this.parent == undefined) return
        this.y = this.parent.height / 2 - this.height / 2
    }
}
